import utils from './utils.js';
import app from './app.js';
/**
 * 编辑模式
 */
export const Model = function(canvas){
	this.lastModel = -1
	this.model = 1
	this.globalCompositeOperation = 'xor'
	this.canvas = canvas
	this.lineWidth = 16
	this.scaling = 1
	this.strokeColor = 'rgba(255, 15, 3, 0.5)'
}

/**
 * 切换编辑模式
 * 1. 画笔    2.套索    3.多边形   4.擦除   5.裁剪   0.拖拽移动 
 */
Model.prototype.changeMode = function(val) {
	// 当上次模式不为移动和裁剪时，记录上次模式，使得更换新图片的时候还是上次编辑模式
	if (val != 0 && val != 5) {
		app.lastModel = val
	}
	
	this.lastModel = this.model
	this.model = val
	//console.log('model:' + this.model + '  lastModel:' + this.lastModel + '  beforeCropModel: ' + app.beforeCropModel)
	if (val < 4) {
		this.globalCompositeOperation = 'xor'
		this.strokeColor = 'rgba(255, 15, 3, 0.5)'
	}
	else {
		this.strokeColor = 'rgba(255, 15, 3, 1)'
		this.globalCompositeOperation = 'destination-out'
	}

	if (val == 3 || val == 5) 
		this._openCoverCanvas()
	else 
		this._closeCoverCanvas()

	if (val != 5 && app.crop) 
		//app.crop.destroy()
		app.crop.hide()
		
	switch(val) {
		case 1: this._modelLine();break;
		case 2: this._modelLasso();break;
		case 3: this._modelPolygon();break;
		case 4: this._modelLine();break;
		default: this.canvas.style.cursor = 'move';
	}
}

/**
 * 设定缩放比例
 */
Model.prototype.setScale = function(val) {
	this.scaling = val
}

/**
 * 设定lineWidth
 */
Model.prototype.changeLineWidth = function(val) {
	this.lineWidth = parseInt(val)
	if (this.globalCompositeOperation == 'xor')
		this.canvas.style.cursor = utils.makeCursor(this.lineWidth)
	else 
		this.canvas.style.cursor = utils.makeCursor(this.lineWidth, 'rgb(255, 255, 255)')
}

/**
 * 画线模式
 */
Model.prototype._modelLine = function () {
	let _this = this
	let canvas = this.canvas
	let ctx = canvas.getContext('2d')
	if (utils.IEVersion() != -1) {
		canvas.style.cursor = 'default'
	} else {
		if (this.model == 1) {
			canvas.style.cursor = utils.makeCursor(this.lineWidth)
		} else {
			canvas.style.cursor = utils.makeCursor(this.lineWidth, 'rgb(255, 255, 255)')
		}
	}
	
	if (utils.browserIsPc()) {
		canvas.onmousedown = function(e) {
			app.brush_model.push(_this.model)
			app.brush_size.push(_this.lineWidth)
			let points = []
			ctx.beginPath()
			ctx.lineCap = 'round';
			ctx.lineJoin = 'round';
			ctx.save()
			ctx.strokeStyle = _this.strokeColor
			ctx.lineWidth = _this.lineWidth / _this.scaling
		    ctx.globalCompositeOperation = _this.globalCompositeOperation
			ctx.moveTo(e.offsetX / _this.scaling, e.offsetY / _this.scaling)
			ctx.lineTo(e.offsetX / _this.scaling, e.offsetY / _this.scaling)
			ctx.stroke()
			
			points.push([e.offsetX, e.offsetY])
			canvas.onmousemove = function(e) {
				ctx.lineTo(e.offsetX / _this.scaling, e.offsetY / _this.scaling)
				ctx.stroke()
				
				points.push([e.offsetX, e.offsetY])
			}
			document.onmouseup = function(e) {
				var shape = {
					type: 'line',
					globalCompositeOperation: _this.globalCompositeOperation,
					scale: _this.scaling,
					lineWidth: _this.lineWidth,
					lineColor: _this.strokeColor,
					fillStyle: 'rgba(255, 15, 3, 0.5)',
					points: points
				}

				app.actions.addObject(shape)
				app.actions.checkBtn()
				ctx.closePath()
				ctx.restore()

				canvas.onmousemove = null
				document.onmouseup = null
				if (localStorage.getItem('remove_guide')) {
					setTimeout(() => {
						$('.remove_guide').addClass('active');
						localStorage.removeItem('remove_guide');
						$('.remove_guide').css({
							left:($('.remove_guide').outerWidth(true)-80)*-1,
							top:($('.remove_guide').outerHeight(true)+$('.function_desk').height()-20)*-1,
						})
					}, 10);
				}
			}
			$('.pensize-change-container').hide();
		}
	} else {
		var time=null;
		canvas.ontouchstart = function(e) {
			if(e.touches.length==2){
				canvas.ontouchmove = null
				document.ontouchend = null
				clearTimeout(time)
				return false;
			}
			time=setTimeout(function(){
				app.brush_model.push(_this.model)
				app.brush_size.push(_this.lineWidth)
				e.preventDefault();
				let rect = canvas.getBoundingClientRect()
				let calcX = e.changedTouches[0].pageX - rect.left
				let calcY = e.changedTouches[0].pageY - rect.top
				let points = []
				ctx.beginPath()
				ctx.lineCap = 'round';
				ctx.lineJoin = 'round';
				ctx.save()
				ctx.strokeStyle = _this.strokeColor
				ctx.lineWidth = _this.lineWidth / _this.scaling
				ctx.globalCompositeOperation = _this.globalCompositeOperation
				ctx.moveTo(calcX / _this.scaling, calcY / _this.scaling)
				ctx.lineTo(calcX / _this.scaling, calcY / _this.scaling)
				ctx.stroke()
				points.push([calcX, calcY])
				canvas.ontouchmove = function(e) {
					e.preventDefault();
					let calcX = e.changedTouches[0].pageX - rect.left
					let calcY = e.changedTouches[0].pageY - rect.top
					ctx.lineTo(calcX / _this.scaling, calcY / _this.scaling)
					ctx.stroke()
					
					points.push([calcX, calcY])
				}
				document.ontouchend = function(e) {
					var shape = {
						type: 'line',
						globalCompositeOperation: _this.globalCompositeOperation,
						scale: _this.scaling,
						lineWidth: _this.lineWidth,
						lineColor: _this.strokeColor,
						fillStyle: 'rgba(255, 15, 3, 0.5)',
						points: points
					}
	
					app.actions.addObject(shape)
					app.actions.checkBtn()
					ctx.closePath()
					ctx.restore()
	
					canvas.ontouchmove = null
					document.ontouchend = null
					if (localStorage.getItem('remove_guide')) {
						setTimeout(() => {
							$('.remove_guide').addClass('active');
							localStorage.removeItem('remove_guide');
						}, 10);
					}
				}
				$('.pensize-change-container').hide();
			},100);
		}
	}
}

/**
 * 套索模式
 */
Model.prototype._modelLasso = function () {
	let _this = this
	let canvas = this.canvas
	let ctx = canvas.getContext('2d')
	canvas.style.cursor = 'default'

	if (utils.browserIsPc()) {
		canvas.onmousedown = function(e) {
			app.brush_model.push(_this.model)
			let points = []
			ctx.beginPath()
			ctx.save()
			ctx.lineWidth = 2 / _this.scaling
	        ctx.strokeStyle = 'rgba(0, 0, 0, 0.8)'
			ctx.globalCompositeOperation = _this.globalCompositeOperation
			ctx.setLineDash([10 / _this.scaling, 7 / _this.scaling]);
			ctx.lineDashOffset = -0;

			ctx.moveTo(e.offsetX / _this.scaling, e.offsetY / _this.scaling)
			ctx.lineTo(e.offsetX / _this.scaling, e.offsetY / _this.scaling)
			ctx.stroke()
			
			points.push([e.offsetX, e.offsetY])
			canvas.onmousemove = function(e) {
				ctx.lineTo(e.offsetX / _this.scaling, e.offsetY / _this.scaling)
				ctx.stroke()

				points.push([e.offsetX, e.offsetY])
			}
			document.onmouseup = function(e) {
				ctx.closePath()
				ctx.restore()

				var shape = {
					type: 'lasso',
					lineWidth: _this.lineWidth,
					scale: _this.scaling,
					globalCompositeOperation: _this.globalCompositeOperation,
					lineColor: 'rgba(0, 0, 0, 1)',
					fillStyle: 'rgba(255, 15, 3, 0.5)',
					points: points
				}
				app.actions.addObject(shape)
				app.actions.checkBtn()
				app.actions.renderAll()
				canvas.onmousemove = null
				document.onmouseup = null
				
				if (localStorage.getItem('remove_guide')) {
					setTimeout(() => {
						$('.remove_guide').addClass('active');
						localStorage.removeItem('remove_guide');
						$('.remove_guide').css({
							left:($('.remove_guide').outerWidth(true)-80)*-1,
							top:($('.remove_guide').outerHeight(true)+$('.function_desk').height()-20)*-1,
						})
					}, 10);
				}
			}
		}
	} else {
		var time=null;
		canvas.ontouchstart = function(e) {
			if(e.touches.length==2){
				canvas.ontouchmove = null
				document.ontouchend = null
				clearTimeout(time)
				return false;
			}
			time=setTimeout(function(){
				app.brush_model.push(_this.model)
				e.preventDefault();
				let points = []
				ctx.beginPath()
				ctx.save()
				ctx.lineWidth = 2 / _this.scaling
				ctx.strokeStyle = 'rgba(0, 0, 0, 0.8)'
				ctx.globalCompositeOperation = _this.globalCompositeOperation
				ctx.setLineDash([10 / _this.scaling, 7 / _this.scaling]);
				ctx.lineDashOffset = -0;
	
				let rect = canvas.getBoundingClientRect()
				let calcX = e.changedTouches[0].pageX - rect.left
				let calcY = e.changedTouches[0].pageY - rect.top
	
				ctx.moveTo(calcX / _this.scaling, calcY / _this.scaling)
				ctx.lineTo(calcX / _this.scaling, calcY / _this.scaling)
				ctx.stroke()
				
				points.push([e.offsetX, e.offsetY])
				canvas.ontouchmove = function(e) {
					e.preventDefault();
					let calcX = e.changedTouches[0].pageX - rect.left
					let calcY = e.changedTouches[0].pageY - rect.top
	
					ctx.lineTo(calcX / _this.scaling, calcY / _this.scaling)
					ctx.stroke()
	
					points.push([calcX, calcY])
				}
				document.ontouchend = function(e) {
					e.preventDefault();
					ctx.closePath()
					ctx.restore()
	
					var shape = {
						type: 'lasso',
						lineWidth: _this.lineWidth,
						scale: _this.scaling,
						globalCompositeOperation: _this.globalCompositeOperation,
						lineColor: 'rgba(0, 0, 0, 1)',
						fillStyle: 'rgba(255, 15, 3, 0.5)',
						points: points
					}
					app.actions.addObject(shape)
					app.actions.checkBtn()
					app.actions.renderAll()
					canvas.ontouchmove = null
					document.ontouchend = null
					
					if (localStorage.getItem('remove_guide')) {
						setTimeout(() => {
							$('.remove_guide').addClass('active');
							localStorage.removeItem('remove_guide');
						}, 10);
					}
				}
			},100)
		}
	}

	
}

/**
 * 多边形模式
 */
Model.prototype._modelPolygon = function() {
	let _this = this
	this.canvas.style.cursor = 'default'

	let canvas = app.board.cover
	let ctx = app.board.ctxCover

	// 每点一下一个点，直到和初始点相交
	// 初始化设置，开启路径
	let points = []
	// 两点相交，闭合路径
	canvas.onmousedown = function(e) {
		app.brush_model.push(_this.model)
		points.push([e.offsetX, e.offsetY])
		// 第一次点击事件，画点
		if (points.length == 1) {
			ctx.beginPath()
			ctx.lineCap = 'round';
			ctx.lineJoin = 'round';
			ctx.save()
			ctx.fillStyle = 'red'
			ctx.arc(parseInt(e.offsetX / _this.scaling), parseInt(e.offsetY / _this.scaling), parseInt(10 / _this.scaling), 0, Math.PI * 2, false);
    		ctx.fill()
    		ctx.restore()
    		ctx.closePath()
    		// 绘制虚线
			canvas.onmousemove = function(e) {
				window.canRun = true;
				utils.throttle(function(context, t, e) {
					if (! points[0]) 
						return
					ctx.clearRect(0, 0, canvas.width, canvas.height)
					ctx.beginPath()
					ctx.save()
					ctx.fillStyle = 'red'
					ctx.arc(parseInt(points[0][0] / _this.scaling), parseInt(points[0][1] / _this.scaling), parseInt(10 / _this.scaling), 0, Math.PI * 2, false);
		    		ctx.fill()
		    		
		    		ctx.restore()
		    		ctx.closePath()

		    		ctx.beginPath()
		    		ctx.save()
		    		ctx.strokeStyle = 'rgba(0, 0, 0, 0.6)'
		    		ctx.globalCompositeOperation = "destination-over";
		    		ctx.setLineDash([10 / _this.scaling , 7 / _this.scaling]);
		    		ctx.lineDashOffset = -0;
			    	ctx.lineWidth = 2 / _this.scaling
		    		ctx.moveTo(points[0][0] / _this.scaling, points[0][1] / _this.scaling)
					for (var i = 1; i < points.length; i++) {
						ctx.lineTo(points[i][0] / _this.scaling, points[i][1] / _this.scaling)
					}
					ctx.lineTo((e.offsetX || e.layerX )/ _this.scaling, (e.offsetY || e.layerY) / _this.scaling)
					ctx.stroke()
					ctx.restore()
					ctx.closePath()
				}, 30, e)
			}
		} 

		// 两点之间画线
		// _this._drawLine(ctx, points)
		// 计算两点距离，判断是否相交
		if ( (points.length > 1) && (_this._pointDistance(points[0], points[points.length - 1]) < 10)) {
			ctx.closePath();
			var shape = {
				type: 'polygon',
				lineWidth: 2,
				scale: _this.scaling,
				lineColor: 'rgba(255, 15, 3, 1)',
				fillStyle: 'rgba(255, 15, 3, 0.5)',
				points: points
			}
			app.actions.addObject(shape)
			app.actions.checkBtn()
			ctx.save()
				ctx.clearRect(0, 0, canvas.width, canvas.height)
				ctx.restore()
			app.actions.renderAll()
			points = []
			ctx.beginPath()
			canvas.onmousemove = null
				
			if (localStorage.getItem('remove_guide')) {
				setTimeout(() => {
					$('.remove_guide').addClass('active');
					localStorage.removeItem('remove_guide');
					$('.remove_guide').css({
						left:($('.remove_guide').outerWidth(true)-80)*-1,
						top:($('.remove_guide').outerHeight(true)+$('.function_desk').height()-20)*-1,
					})
				}, 10);
			}
		}
	}
}

/**
 * 两点之间画线
 */
Model.prototype._drawLine = function(ctx, points) {
	var length = points.length,
		_this = this

	if (length < 2) {
		ctx.moveTo(points[0][0] / _this.scaling, points[0][1] / _this.scaling)
	} else {
		ctx.save()
		ctx.strokeStyle = 'rgba(0, 0, 0, 0.7)'
		ctx.lineWidth = 3 / _this.scaling
		ctx.setLineDash([10 / _this.scaling, 7 / _this.scaling]);
	    ctx.lineDashOffset = -0;
		ctx.lineTo(points[length-1][0] / _this.scaling, points[length-1][1] / _this.scaling)
		ctx.stroke()
		ctx.restore()
	}
}

/**
 * 计算两点之间距离
 */
Model.prototype._pointDistance = function(point1, point2) {
	var distance = Math.sqrt( (Math.pow( (point2[1] - point1[1]), 2) + Math.pow((point2[0] - point1[0]), 2)), 2)
	return distance
}

/**
 * 开启cover层画布，在上面画多边形的轨迹
 */
Model.prototype._openCoverCanvas = function() {
	app.board.cover.width = this.canvas.width
	app.board.cover.height = this.canvas.height
	app.board.cover.style.width = this.canvas.style.width
	app.board.cover.style.height = this.canvas.style.height
	app.board.cover.style.top = this.canvas.offsetTop + 'px'
	app.board.cover.style.left = this.canvas.offsetLeft + 'px'
	app.board.cover.style.display = 'block'
}

/**
 * 关闭cover层画布
 */
Model.prototype._closeCoverCanvas = function() {
	app.board.cover.style.display = 'none'
}

/**
 * 更新裁剪区域显示
 */
Model.prototype.updateCropCover = function() {
	let cover = app.board.cover,
		ctx = app.board.ctxCover

	ctx.save()
	ctx.clearRect(0, 0, cover.width, cover.height)
	ctx.fillStyle = 'rgba(255, 255, 255, 0.7)'
	ctx.fillRect(0, 0, cover.width, cover.height)
	ctx.clearRect(app.crop.cropBox.offsetLeft / app.zoom.scaling,
				  app.crop.cropBox.offsetTop / app.zoom.scaling,
				  app.crop.cropBox.offsetWidth / app.zoom.scaling,
				  app.crop.cropBox.offsetHeight / app.zoom.scaling )
	ctx.restore()
}